export const drcBoundaryColor = '#a80022'
// export const drcProvinceColor = '#FFC300'
export const drcProvinceColor = '#a80022'
export const drcTerritoryColor = '#000'
export const agricultureFillColor = '#ECD589'
export const locationColor = '#0ED029'
export const locationFillColor = '#0ED029'
export const highlightColor = 'white'
export const bboxColor = '#cc0033'

export const location_style = {
  color: '',
  weight: 1.5,
  opacity: 1,
  fill: true,
  fillColor: locationFillColor,
  fillOpacity: 0.8
}

export const highlight_style = {
  color: highlightColor,
  weight: 3,
  zIndex: 1000
}

export const bbox_style = {
  color: bboxColor,
  weight: 4,
  opacity: 1,
  fill: false
}

export const agriculture_style = {
  color: agricultureFillColor,
  weight: 1.5,
  opacity: 1,
  fill: true,
  fillColor: agricultureFillColor
}

export const drc_boundary = {
  color: drcBoundaryColor,
  weight: 2,
  opacity: 0.8,
  fill: false
}

export const drc_provinces = {
  color: drcProvinceColor,
  weight: 1.5,
  fillOpacity: 0,
  opacity: 0.6,
  fill: true,
  dashArray: '10, 5'
}

export const drc_territories = {
  color: drcTerritoryColor,
  weight: 1.5,
  fillOpacity: 0,
  opacity: 0.6,
  fill: true,
  dashArray: '10, 5'
}
